import axiosInstance from './axiosInstance';

/**
 * Support/Help tickets.
 * The backend scopes results by role automatically:
 *  - admin / super_admin → all tickets
 *  - any other role      → only the caller's own tickets
 */
const ticketService = {
  list: async ({ status, search } = {}) => {
    const params = {};
    if (status) params.status = status;
    if (search) params.search = search;
    const res = await axiosInstance.get('/tickets', { params });
    return res.data;
  },

  create: async (payload) => {
    const res = await axiosInstance.post('/tickets', payload);
    return res.data;
  },

  get: async (id) => {
    const res = await axiosInstance.get(`/tickets/${id}`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await axiosInstance.patch(`/tickets/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await axiosInstance.delete(`/tickets/${id}`);
    return res.data;
  },
};

export default ticketService;
